<template>
  <div>
    <a-select
      :disabled="disabled"
      :multiple="false"
      :placeholder="placeholder"
      :value="value"
      :class="class"
      allow-clear
      option-filter-prop="title"
      show-search
      @change="onChange"
      :virtual="false"
    >
      <a-select-option
        v-for="item in records"
        :contractPricingManner="item.contractPricingManner"
        :key="item.id"
        :title="item.name"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, watch } from "vue";
import { ContractSimpleListReq, ProfileService } from "@/views/contract";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { useRoute } from "vue-router";

/**
 * 合同选择器
 *
 * 使用方式:
 * <contract-select v-model:value="formRef.contractId"></contract-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "ContractSelect",
  props: {
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },

    projectId: {
      type: String,
      default: undefined,
    },
    distinguish: {
      type: String,
      default: undefined,
    },
    //
    paymentContract: {
      type: String,
      default: undefined,
    },
    addRightBizType: {
      type: String,
      default: undefined,
    },
    contractStatus: {
      type: Array,
      default: () => [],
    },
    class: {
      type: String,
      default: "append-to-body",
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    
  },
  emits: ["update:value", "change", "changetype"],
  setup(props, { emit }) {
    const { data: records, run, loading } = ProfileService.useSimpleListApi();
    const route = useRoute();
    const onChange = async (id, option) => {
      // console.log(option, ">>>>>>>>>>>>>>>>>>>>>>>________????????");
      emit("update:value", id);
      emit("change", id, option);
      emit("changetype", option);
    };

    const search = async () => {
      const req = new ContractSimpleListReq();
      if (props.projectId) {
        req.merge({
          projectId: props.projectId,
          distinguish: props.distinguish,
          paymentContract: props.paymentContract,
        });
      }
      if (_.isArray(props.contractStatus) && props.contractStatus.length) {
        req.merge({
          contractStatusList: props.contractStatus.join(","),
          // contractStatus: props.contractStatus.join(","),
          distinguish: props.distinguish,
          paymentContract: props.paymentContract,
        });
      }
      if(props.addRightBizType){
        req.merge({
          addRightBizType: props.addRightBizType,
        });
      }
      if(route['query']['projectId']){
        req.merge({
          firstDisplayProjectId: route['query']['projectId'],
        });
      }
      await run(req);
      //编辑合同时，回显使用
      if (props.externalData.contractId&&!records.value.some((i: any) => i.id === props.value) ){
        // // console.log(records.value, "====================", props.externalData);
        records.value.unshift({
          id: props.externalData.contractId,
          name: props.externalData.contractName,
          current: 0,
          size: 0,
          total: 0,
          records: [],
          contractPricingManner: props.externalData.contractPricingManner,
          filterTotalAmount: undefined,
          remark: undefined
        });
      }
    };

    watch(
      () => props.externalData?.contractId,
      async (n) => {
        if (n&&!props.isEdit) {
          emit("change", n);
        }
        // console.log(props.distinguish, "props.distinguish>>>>>>>");
        await search();
      },
      { immediate: true }
    );

    // 修改项目时, 重新获取项目下的合同
    watch(
      () => props.projectId,
      async (newValue) => {
        // if (newValue) {
          await search();
        // }
      },
      { immediate: true }
    );
    onMountedOrActivated(()=>{
      search();
    })
    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
